import { render, staticRenderFns } from "./EditAgent.vue?vue&type=template&id=4f0d4afc&scoped=true&"
import script from "./EditAgent.vue?vue&type=script&lang=js&"
export * from "./EditAgent.vue?vue&type=script&lang=js&"
import style0 from "./EditAgent.vue?vue&type=style&index=0&id=4f0d4afc&prod&lang=scss&scoped=true&"
import style1 from "./EditAgent.vue?vue&type=style&index=1&id=4f0d4afc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0d4afc",
  null
  
)

export default component.exports